import { render, staticRenderFns } from "./AdminMenuListItem.vue?vue&type=template&id=66d1e0a8&scoped=true&"
import script from "./AdminMenuListItem.vue?vue&type=script&lang=js&"
export * from "./AdminMenuListItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuListItem.vue?vue&type=style&index=0&id=66d1e0a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1e0a8",
  null
  
)

export default component.exports